export default {
    // Full email/whatsapp thread for a booking (same source the Daily Departures screen uses)
    GET_BY_BOOKING: (id, query) => `/bookingConversation/byBooking/${id}${query ? `?${query}` : ''}`,
    // Send / reply on an accommodation booking thread
    SEND_MAIL: () => `/bookingAccommodation/accommodation/sendmMail`,
};
